const DividerLine = ({mt, mb}) => {
    return (
        <div className={`mt-${mt} mb-${mb} border-b-2 border-gray-300 w-almost mx-auto`}></div>
    )
}

export default DividerLine